module.exports = __webpack_public_path__ + "img/zgtitle.f0ea7e59.png";